import React from 'react'
import cx from 'classnames'

import styles from './Link.module.css'

const Link = (props) => {
  const { className, as: Tag = 'a', danger = false, disabled = false, ...rest } = props

  const handleClick = (e) => {
    if (!rest.onClick) {
      return
    }

    e.preventDefault()
    rest.onClick()
  }

  return (
    <Tag
      {...rest}
      className={cx(styles.Link, { [styles.Danger]: danger, [styles.Disabled]: disabled }, className)}
      onClick={handleClick}
    />
  )
}

export default Link
